import { isFeatureEnabled } from '@lumapps/features';

import { BACK_OFFICE_BETA_FF } from '../constants';

export const isBackOfficeBetaEnabled = isFeatureEnabled(BACK_OFFICE_BETA_FF);
